import { CheckIcon, CopyIcon } from '@phosphor-icons/react';
import { useGT } from 'gt-react';
import { useChatCopy } from './useChatCopy';

const COPIED_MS = 1200;

export function ChatCodeBlock({ lang, code }: { lang: string; code: string }) {
  const gt = useGT();
  const { copied, copy } = useChatCopy('code', COPIED_MS);

  const copyLabel = copied
    ? gt('Copied', { context: 'confirmation after copying a code block' })
    : gt('Copy', { context: 'button copying a code block to the clipboard' });

  return (
    <div className="overflow-hidden rounded-lg bg-stone-100 dark:bg-stone-800">
      <div className="flex items-center justify-between gap-2 border-b border-stone-200 px-3 py-1.5 dark:border-stone-700">
        <span className="font-mono text-[0.8125rem] text-stone-500">
          {lang}
        </span>
        <button
          type="button"
          className="inline-flex items-center gap-1 rounded-md px-1.5 py-0.5 text-xs text-stone-500 hover:bg-stone-200 hover:text-stone-800 dark:hover:bg-stone-700 dark:hover:text-stone-100"
          onClick={() => void copy(code)}
          aria-label={copyLabel}
        >
          {copied ? (
            <CheckIcon className="h-3.5 w-3.5" />
          ) : (
            <CopyIcon className="h-3.5 w-3.5" />
          )}
          <span>{copyLabel}</span>
        </button>
      </div>
      <pre className="my-0 overflow-x-auto p-3">
        <code className="bg-transparent p-0 font-mono text-[0.8125rem] text-stone-700 dark:text-stone-200">
          {code}
        </code>
      </pre>
    </div>
  );
}
